<div class="subida-masiva-container">
  <div class="card-acciones">
    <h2>Subir archivo de usuarios</h2>
    <p>Sigue las instrucciones para importar tus usuarios de forma rápida:</p>
    
    <div class="instrucciones">
      <div class="paso">
        <span class="numero">1</span>
        <span class="descripcion">Descarga la plantilla oficial en formato Excel haciendo clic en el botón de abajo.</span>
      </div>
      <div class="paso">
        <span class="numero">2</span>
        <span class="descripcion">Diligencia la información de los usuarios respetando las columnas indicadas.</span>
      </div>
      <div class="paso">
        <span class="numero">3</span>
        <span class="descripcion">Selecciona o arrastra el archivo Excel y verifica la vista previa antes de guardarlo.</span>
      </div>
    </div>

    <div class="contenedor-descarga">
      <button class="btn-descargar" (click)="descargarPlantilla()" [disabled]="cargando">
        <mat-icon>cloud_download</mat-icon>
        Descargar Plantilla Excel
      </button>
    </div>

    <!-- Área de selección de archivo -->
    <div class="area-carga" [class.tiene-archivo]="selectedFile" [class.procesando]="procesandoArchivo">
      <input type="file" id="fileInput" accept=".xlsx, .xls" (change)="onFileChange($event)" style="display: none;" #fileInput />
      
      <div class="contenido-carga" *ngIf="!selectedFile" (click)="fileInput.click()">
        <mat-icon class="icono-nube">backup</mat-icon>
        <p class="texto-principal">Haz clic para seleccionar tu archivo Excel</p>
        <p class="texto-secundario">Formatos admitidos: .xlsx, .xls</p>
      </div>

      <div class="contenido-archivo-cargado" *ngIf="selectedFile">
        <mat-icon class="icono-excel">description</mat-icon>
        <div class="info-archivo">
          <p class="nombre-archivo">{{ fileName }}</p>
          <p class="tamanio-archivo">{{ (selectedFile.size / 1024) | number:'1.0-2' }} KB</p>
        </div>
        <button class="btn-limpiar" (click)="resetFile()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Vista previa dinámica de la tabla -->
  <div class="card-vista-previa" *ngIf="selectedFile && headers.length > 0">
    <h3>Vista Previa del Archivo ({{ rows.length }} registros detectados)</h3>
    <div class="tabla-scroll-contenedor">
      <table class="tabla-dinamica">
        <thead>
          <tr>
            <th *ngFor="let header of headers">{{ header }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td *ngFor="let cell of row">{{ cell !== null && cell !== undefined ? cell : '-' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Tarjeta de éxito -->
  <div class="card-exito" *ngIf="successMessage">
    <mat-icon class="icono-exito">check_circle_outline</mat-icon>
    <div class="contenido-exito">
      <h4>Importación Exitosa</h4>
      <p>{{ successMessage }}</p>
      <div class="contenedor-boton-exito">
        <button class="btn-ir-listado" (click)="volver()" type="button">
          Ver Listado de Usuarios
        </button>
      </div>
    </div>
    <button class="btn-cerrar-exito" (click)="successMessage = ''" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Tarjeta de error -->
  <div class="card-error" *ngIf="errorMessage">
    <mat-icon class="icono-error">error_outline</mat-icon>
    <div class="contenido-error">
      <h4>Error al procesar el archivo</h4>
      <p>{{ errorMessage }}</p>
    </div>
    <button class="btn-cerrar-error" (click)="errorMessage = ''" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Botones de Acción final -->
  <div class="botones-navegacion">
    <button class="btn-volver" (click)="volver()">
      Regresar
    </button>
    <button class="btn-guardar" (click)="enviarArchivo()" [disabled]="!selectedFile || cargando || procesandoArchivo">
      <span *ngIf="!cargando">Importar Usuarios</span>
      <span *ngIf="cargando">Cargando...</span>
    </button>
  </div>
</div>
